export function validationError(message: string) {
    return {
        type: 'validation',
        message,
    };
}
